export const BOOKING = "booking";
export const DELETE = "delete";